(function () {
  var STORAGE_KEY = 's4x4_recently_viewed';
  var MAX_STORED = 8;
  var MAX_RENDERED = 3;

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function trackCurrentProduct() {
    var snapshotTag = document.querySelector('[data-recently-viewed-snapshot]');
    if (!snapshotTag) return;

    var product;
    try {
      product = JSON.parse(snapshotTag.textContent);
    } catch (error) {
      return;
    }
    if (!product || !product.handle) return;

    var items = getStored().filter(function (item) {
      return item.handle !== product.handle;
    });
    items.unshift(product);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_STORED)));
    } catch (error) {
      // localStorage unavailable (private browsing quota, etc.) — skip tracking silently
    }
  }

  function renderInto(root) {
    var wrapper = root.querySelector('[data-recently-viewed]');
    var column = root.querySelector('[data-recently-viewed-column]');
    if (!wrapper || !column) return;

    var items = getStored();

    if (!items.length) {
      column.hidden = true;
      return;
    }

    column.hidden = false;
    wrapper.textContent = '';

    items.slice(0, MAX_RENDERED).forEach(function (item) {
      var link = document.createElement('a');
      link.href = item.url;
      link.className = 's4x4-search-rv-item';

      var imageSpan = document.createElement('span');
      imageSpan.className = 's4x4-search-rv-image';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        imageSpan.appendChild(img);
      }

      var titleSpan = document.createElement('span');
      titleSpan.className = 's4x4-search-rv-title';
      titleSpan.textContent = item.title || '';

      var priceSpan = document.createElement('span');
      priceSpan.className = 's4x4-search-rv-price';
      priceSpan.textContent = item.price || '';

      link.appendChild(imageSpan);
      link.appendChild(titleSpan);
      link.appendChild(priceSpan);
      wrapper.appendChild(link);
    });
  }

  trackCurrentProduct();

  document.addEventListener('search-takeover:open', function (event) {
    if (event.target && typeof event.target.querySelector === 'function') {
      renderInto(event.target);
    }
  });
})();
